/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon20Light = forwardRef('MediaUiAEjectIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.997 11.944A1.3 1.3 0 0 0 4.054 14h11.891c1.058 0 1.673-1.195 1.058-2.056l-5.945-8.323a1.3 1.3 0 0 0-2.116 0l-5.945 8.323ZM4.054 13a.3.3 0 0 1-.244-.474l5.946-8.324a.3.3 0 0 1 .488 0l5.945 8.324a.3.3 0 0 1-.244.474H4.055Z" }),
        React.createElement("path", { d: "M3.5 16a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-13Z" })));
});
